import { Place as PlaceIcon } from '@material-ui/icons';
import PropTypes from 'prop-types';
import React from 'react';

const PointIcon = ({ fillColor = 'black', fontSize = undefined, strokeColor = 'white' }) => (
    <PlaceIcon stroke={strokeColor} style={{ color: fillColor, fontSize }} />
);

PointIcon.propTypes = {
    fillColor: PropTypes.string,
    fontSize: PropTypes.string,
    strokeColor: PropTypes.string,
};

export default PointIcon;
